<h1 *ngIf="!isRecertification" class="page-title">Products</h1>
<div *ngIf="!isRecertification"><a routerLink="/practitioner/purchase-history">View Purchase History</a></div>
<h1 *ngIf="isRecertification" class="page-title">Thank you</h1>
<section *ngIf="isRecertification">

	<p>You have successfully completed the Credential Maintenance Program (CMP)! Through this accomplishment, 
		you have demonstrated the level of excellence required to maintain your credentials with the National Board for Respiratory Care. 
		A digital version of the certificate recognizing that accomplishment can be found under 'My Documents' on the left navigation bar. 
		You may purchase a printed copy of your certificates and a wallet card below. </p>

    <p>Notify the NBRC of any changes in your mailing or email address online at nbrc.org or by phone at 913.895.4900 to ensure you 
		receive important notifications about your credential expiration in the future. 
		Please contact us at <a href="service@nbrc.org">service@nbrc.org</a> or 913.895.4900 
		if you have any questions or need further assistance. </p>


    <!-- <p>You have successfully completed the Credential Maintenance Program (CMP)! Through this accomplishment, you have
      demonstrated the level of excellence required to maintain your credential(s) with the National Board for
      Respiratory Care. A certificate and wallet card with your new expiration date will be mailed to you within 30 days
      after your certification was due.</p>
    <p>The following information is provided as a reminder for your next five year cycle:</p>
    <ul>
      <li>To maintain your credential, you MUST renew your credential through the Credential Maintenance Program (CMP).
        The CMP is your pathway to recertifying ANY of your NBRC credentials.</li>
      <li>Detailed information on the CMP requirements and processes is available online at <a
          href="http://NBRC.org">nbrc.org</a>. Click on the &ldquo;Credentialed Practitioners&rdquo; section to login
        and obtain the information you need to get started.</li>
      <li>You will be sent a CMP Invoice each year. Individuals who pay their CMP fee each consecutive year will not be required to submit a fee when 
          recertifying at the end of their five-year credential term. If you do not pay the CMP fee each consecutive year, you will owe $25 for each 
          year not paid during your five-year credential term.</li>
	    <li>We are constantly looking for ways to champion and inform you, our credentialed practitioners. 
        We offer a single fee for all products and services, make the latest credentialing news available to all practitioners online at nbrc.org 
        and provide representation with organizations and state agencies that impact your profession.</li>
      <li>It is imperative that you keep your email and mailing addresses up to date with the NBRC. Please notify the
        NBRC of any changes in your name or address online at <a href="http://www.nbrc.org">www.nbrc.org</a> or by mail
        at 10801 Mastin Street, Suite 300, Overland Park, KS 66210.</li>
    </ul>
    <p>If you have questions regarding this notice, please contact us at <a href="tel:9138954900">913.895.4900</a> or <a
        href="Service@nbrc.org">Service@nbrc.org</a>.</p> -->
  </section>


<div class="item-list">
	<header class="item-list__header">
		<h2 class="item-list__title item-title">Select Item </h2>
		<h2 class="item-list__title price-title">Unit Price </h2>
		<h2 class="item-list_title">Quantity</h2>
	</header>

	<ul class="list list--bare">
		<li *ngFor="let product of productsForPurchase; let i = index;">
			
			<span class="item-container">
				<span class="description">				
					<input type="checkbox" [(checked)]="product.selected" (click)="onItemChecked($event.target.checked, i)">
					{{product.title}}
					<img *ngIf="product.image!==''" class="zoom item-image" [src]="product.image" alt="product image">
					<div *ngIf="product.selected && product.isPin" class="pininitials">
						What initials should be on the pin? <input type="text" [(ngModel)]="product.initials" appUpperCase maxlength="3">
					</div>	
				</span>
				<span class="price-container"> 
					<label *ngIf="product.effectivePrice === 0">Free</label>
					<label *ngIf="!product.effectivePrice === 0">${{product.effectivePrice  | number : '1.2-2'}}</label>
					<label class="strikethrough-disable" *ngIf="product.effectivePrice !== product.inactivePrice">${{product.inactivePrice  | number : '1.2-2'}}</label>				
				</span>			
				<span class="quantity-container">
					<input [disabled]="product.effectivePrice===0" [min]="1" class="input input--small" [(ngModel)]="product.quantity"
					(input)="limitInputLength($event, 2)"
					id="quantity" name="quantity" type="number" min="0" max="10" maxlength="2">			 			
				</span>
			</span>
			<div class="item-warning" *ngIf="product.selected && isCertificate(product)">
				Allow up to three weeks for your certificate to be mailed and go to ‘My Documents’ to access an electronic certificate after submitting your payment.
			</div>	

			<div class="item-warning" *ngIf="product.selected && isWalletCard(product)">
				Allow up to three weeks for your wallet card to be mailed after submitting your payment. 
			</div>	

			<div class="item-warning" *ngIf="product.selected && isPin(product)">
				<p>
				Pins are personalized with initials, original credential date and the registry number for the RRT. 
		  		If you wish to order pin for a credentialed practitioner other than yourself, please contact 
		  		<a href="mailto:Service@nbrc.org">Service@nbrc.org</a>.</p>
				<p>Please allow up to six weeks to receive your personalized lapel pin.</p>
			</div>	
		</li>		
	</ul>

	<!-- <div *ngIf="showCertificateWarning">
		<p>
			<strong>
				Allow up to three weeks for your certificate to be mailed and go to ‘My Documents’ to access an electronic certificate after submitting your payment.
			</strong>
		</p>
    </div>	
	
	<div *ngIf="showCardWarning">
		<p>
			<strong>
				Allow up to three weeks for your wallet card to be mailed after submitting your payment. 
			</strong>
		</p>
    </div>				  

	<div *ngIf="showPinWarning">
		<p>
		<strong>Pins are personalized with initials, original credential date and the registry number for the RRT. 
		  If you wish to order pin for a credentialed practitioner other than yourself, please contact 
		  <a href="mailto:Service@nbrc.org">Service@nbrc.org</a>.</strong></p>
		<p><strong>
		  Please allow up to six weeks to receive your personalized lapel pin.
		</strong></p>
    </div> -->				  


	
	<button class="button form-actions__item" type="button" (click)="addToCartAndPay()">
		Add to cart and pay	
	</button>
</div>